export interface SearchState {
  error?: Error;
  showSuggestions: boolean;
  query: string;
  refinement: string;
}

export const initialSearchState: SearchState = {
  query: "",
  refinement: "",
  showSuggestions: false,
};
